import React from 'react';
type GoldPlaqueProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function GoldPlaque({
  children,
  tone = 'dark'
}: GoldPlaqueProps) {
  return <p className={`inline-flex items-center gap-2.5 rounded-full border px-4 py-2 text-[12px] font-bold uppercase tracking-[0.16em] sm:px-5 sm:text-[13px] ${tone === 'dark' ? 'border-gold/50 bg-gold/[0.08] text-gold' : 'border-gold-dark/40 bg-cream text-gold-ink'}`} data-id="element-272" data-mp="11ik2ga81abtj">
      <span aria-hidden="true" className={`h-2 w-2 shrink-0 rounded-full ${tone === 'dark' ? 'bg-gold' : 'bg-gold-dark'}`} data-id="element-273" data-mp="dsz68pmvdi2b" />
      {children}
    </p>;
}